import { SrPartialPackingTypeMap } from '@plato/data/starrocks/types';

export const isPackingTypeMultipleOfX = (partialPackingType?: string) => {
    if (!partialPackingType) {
        return false;
    }

    return [
        SrPartialPackingTypeMap.NO_PACKAGE_BREAK as string,
        SrPartialPackingTypeMap.ONLY_ROUND_DOWN,
        SrPartialPackingTypeMap.ONLY_ROUND_DOWN,
    ].includes(partialPackingType);
};
